import React from 'react';
import '../../ShabbatWidget.css';
import { formatShabbatTimeRule } from '../../shabbatZmanUtils';
import LeyningDisplay from '../../../shared/LeyningDisplay';

const Card = ({ shabbat, processedCustomTimes, drashaText, loading, error, onRetry, title = 'זמני שבת', showTitle = true, dayEntryTime, dayExitTime, showTimeRule = false, showEntryExit = true, shabbatLeyning, showLeyning, showHaftarah, leyningDisplayMode }) => {
  if (loading) {
    return (
      <div style={styles.stateContainer}>
        <div style={styles.loading}>טוען זמני שבת...</div>
      </div>
    );
  }

  if (error) {
    return (
      <div style={styles.stateContainer}>
        <div style={styles.error}>{error}</div>
        {onRetry && (
          <button onClick={onRetry} style={styles.retryButton}>נסה שוב</button>
        )}
      </div>
    );
  }

  if (!shabbat) {
    return (
      <div style={styles.stateContainer}>
        <div style={styles.loading}>אין נתוני שבת</div>
      </div>
    );
  }

  return (
    <div
      style={{
        padding: '20px',
        direction: 'rtl',
        maxWidth: '400px',
        height: '100%',
        display: 'flex',
        flexDirection: 'column'
      }}
    >
      {/* Header */}
      {showTitle && (
        <div style={{
          display: 'flex',
          alignItems: 'center',
          gap: '8px',
          borderBottom: '1px solid #D7CCC8',
          paddingBottom: '8px',
          marginBottom: '15px'
        }}>
          <span className="material-symbols-outlined" style={{ color: '#8D6E63' }}>candlestick_chart</span>
          <h3 style={{
            margin: 0,
            fontWeight: 'bold',
            color: '#3E2723',
            fontSize: '18px',
          }}>{title}</h3>
        </div>
      )}

      {/* פרשה */}
      <div style={{ textAlign: 'center', marginBottom: '16px' }}>
        {shabbat.meta?.parshaShowPrefix !== false && <div style={{ fontSize: '14px', color: '#795548' }}>פרשת</div>}
        <div style={{
          fontSize: '32px',
          fontWeight: 'bold',
          color: '#3E2723',
        }}>
          {shabbat.meta?.parsha || shabbat.parsha || 'בהר - בחוקותי'}
        </div>
        {shabbat.meta?.parshaSubtitle && (
          <div style={{ fontSize: '16px', fontWeight: '700', color: '#3E2723', marginTop: '4px' }}>
            {shabbat.meta.parshaSubtitle}
          </div>
        )}
      </div>

      {/* קריאה */}
      {(showLeyning || showHaftarah) && shabbatLeyning && (
        <div style={{
          padding: '10px 12px',
          marginBottom: '16px',
          borderRadius: '4px',
          backgroundColor: '#ffffff',
          border: '1px solid #D7CCC8',
          boxShadow: '0 2px 4px rgba(0,0,0,0.05)',
        }}>
          <LeyningDisplay
            leyning={shabbatLeyning}
            mode={leyningDisplayMode}
            showHaftarah={showHaftarah}
            showMaftir={leyningDisplayMode === 'full'}
            compact={false}
          />
        </div>
      )}

      {/* דרשת ליל שבת */}
      {drashaText && (
        <div style={{
          marginBottom: '16px',
          textAlign: 'center',
        }}>
          <div style={{
            fontSize: '18px',
            color: '#3E2723',
            fontWeight: 'bold',
            whiteSpace: 'pre-wrap',
          }}>
            {drashaText}
          </div>
        </div>
      )}

      {/* גריד זמנים */}
      <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '16px' }}>

        {/* כניסת שבת - רקע קרם */}
        {showEntryExit && (
          <div style={{
            backgroundColor: '#FFF8E1',
            borderRadius: '4px',
            padding: '12px',
            textAlign: 'center',
            border: '1px solid #D7CCC8',
            boxShadow: '0 2px 4px rgba(0,0,0,0.05)'
          }}>
            <div style={{ fontSize: '12px', color: '#795548', marginBottom: '4px', fontWeight: 'bold' }}>כניסת שבת</div>
            <div style={{
              fontWeight: 'bold',
              fontSize: '20px',
              color: '#3E2723'
            }}>
              {dayEntryTime || shabbat.meta?.candleLighting || shabbat.friday?.candleLighting || shabbat.candleLighting || '--:--'}
            </div>
          </div>
        )}

        {/* צאת שבת - רקע חום כהה */}
        {showEntryExit && (
          <div style={{
            backgroundColor: '#3E2723',
            borderRadius: '4px',
            padding: '12px',
            textAlign: 'center',
            border: '1px solid #5D4037',
            boxShadow: '0 2px 4px rgba(0,0,0,0.1)'
          }}>
            <div style={{ fontSize: '12px', color: '#D7CCC8', marginBottom: '4px', fontWeight: 'bold' }}>צאת שבת</div>
            <div style={{
              fontWeight: 'bold',
              fontSize: '20px',
              color: '#FFECB3'
            }}>
              {dayExitTime || shabbat.meta?.havdalah || shabbat.shabbat?.havdalah || shabbat.havdalah || '--:--'}
            </div>
          </div>
        )}

        {/* זמנים מותאמים אישית (אם יש) - קודם שישי, אחר כך שבת */}
        {processedCustomTimes
          .filter(ct => (ct.day || 'friday') === 'friday')
          .sort((a, b) => {
            const timeToMinutes = (timeStr) => {
              if (!timeStr || timeStr === '--:--') return -1;
              const [hours, minutes] = timeStr.split(':').map(Number);
              return hours * 60 + minutes;
            };
            return timeToMinutes(a.time) - timeToMinutes(b.time);
          })
          .map((ct, index) => (
            <div key={`friday-${index}`} style={{
              backgroundColor: '#ffffff',
              borderRadius: '4px',
              padding: '8px',
              textAlign: 'center',
              border: '1px solid #EFEBE9',
              gridColumn: processedCustomTimes.length === 1 ? 'span 2' : 'auto'
            }}>
              <div style={{ fontSize: '11px', color: '#8D6E63', fontWeight: 'bold' }}>{ct.label}</div>
              {showTimeRule && formatShabbatTimeRule(ct) && (
                <div style={{ fontSize: '9px', color: '#8D6E63', opacity: 0.7, marginBottom: '2px' }}>{formatShabbatTimeRule(ct)}</div>
              )}
              <div style={{ fontWeight: 'bold', fontSize: '16px', color: '#3E2723' }}>{ct.time}</div>
            </div>
          ))}
        {processedCustomTimes
          .filter(ct => (ct.day || 'friday') === 'shabbat')
          .sort((a, b) => {
            const timeToMinutes = (timeStr) => {
              if (!timeStr || timeStr === '--:--') return -1;
              const [hours, minutes] = timeStr.split(':').map(Number);
              return hours * 60 + minutes;
            };
            return timeToMinutes(a.time) - timeToMinutes(b.time);
          })
          .map((ct, index) => (
            <div key={`shabbat-${index}`} style={{
              backgroundColor: '#ffffff',
              borderRadius: '4px',
              padding: '8px',
              textAlign: 'center',
              border: '1px solid #EFEBE9',
              gridColumn: processedCustomTimes.length === 1 ? 'span 2' : 'auto'
            }}>
              <div style={{ fontSize: '11px', color: '#8D6E63', fontWeight: 'bold' }}>{ct.label}</div>
              {showTimeRule && formatShabbatTimeRule(ct) && (
                <div style={{ fontSize: '9px', color: '#8D6E63', opacity: 0.7, marginBottom: '2px' }}>{formatShabbatTimeRule(ct)}</div>
              )}
              <div style={{ fontWeight: 'bold', fontSize: '16px', color: '#3E2723' }}>{ct.time}</div>
            </div>
          ))}
      </div>
    </div>
  );
};

const styles = {
  stateContainer: {
    width: '100%',
    padding: '20px',
    textAlign: 'center',
    border: '4px double #5D4037',
    borderRadius: '8px',
    backgroundColor: '#FDFBF7'
  },
  loading: { fontSize: '16px', color: '#3E2723' },
  error: { fontSize: '14px', color: '#D32F2F', marginBottom: '10px' },
  retryButton: {
    padding: '5px 15px',
    background: '#8D6E63',
    color: 'white',
    border: 'none',
    borderRadius: '4px',
    cursor: 'pointer'
  }
};

export default Card;